import { render, staticRenderFns } from "./FormViewItem.vue?vue&type=template&id=133569e9&scoped=true"
import script from "./FormViewItem.vue?vue&type=script&lang=js"
export * from "./FormViewItem.vue?vue&type=script&lang=js"
import style0 from "./FormViewItem.vue?vue&type=style&index=0&id=133569e9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133569e9",
  null
  
)

export default component.exports